module.exports = __webpack_public_path__ + "media/1_3-18.5b6002be.mp3";